module.exports = "https://cdn-static.kwai.net/kos/s101/nlav11312/kibt-fe-shop-c-outside-h5/prod/images/coupon-title-bg-v1.e68c5b5f8a.png";